export function melhorEnvioStatus(status: string) {
  switch(status){
    case 'pending':
      return 'Pendente';
    case 'paid':
      return 'Paga';
    case 'released':
      return 'Liberada';
    case 'posted':
      return 'Postada';
    case 'delivered':
      return 'Entregue';
    case 'canceled':
      return 'Cancelada';
    case 'undelivered':
      return 'Não entregue';
    default:
      return '';
  }
}